import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Task } from '@completion/models';
import { getCurrentTask, getTasks } from '@completion/selectors';
import * as taskAction from '../../core/store/actions/task.action';
import { TaskState } from '../../core/store/reducers/task';

@Component({
  selector: 'app-task-selector',
  templateUrl: './task-selector.component.html',
  styleUrls: ['./task-selector.component.scss'],
  standalone: false,
})
export class TaskSelectorComponent implements OnInit, OnDestroy {
  /** Stream of all tasks, fed into the PrimeNG select as `[options]`. */
  readonly taskList$: Observable<Task[]>;
  /** Current selection — bound via `[(ngModel)]` to the `<p-select>`. */
  currentTask: Task | null = null;

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly store: Store<TaskState>,
    private readonly router: Router,
  ) {
    this.taskList$ = this.store.pipe(select(getTasks));
  }

  ngOnInit(): void {
    this.store.pipe(takeUntil(this.destroy$), select(getCurrentTask)).subscribe((task) => {
      this.currentTask = task ?? null;
      if (!this.currentTask) {
        this.store.dispatch(new taskAction.ClearCurrentTask());
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  /** Triggered by `<p-select>` (onChange / clear). */
  onTaskSelected(task: Task | null): void {
    if (task && task.id) {
      this.store.dispatch(new taskAction.CurrentTask(task));
    } else {
      this.store.dispatch(new taskAction.ClearCurrentTask());
    }
    this.router.navigate(['dashboard']);
  }

  /** Helper used by the dropdown's selected-item / item templates. */
  displayValue(task: Task | null | undefined): string {
    return task ? `${task.number} - ${task.name}` : '';
  }
}
